import { openCreateOneOnOneDrawer } from 'screens/oneOnOneRabbit/creationDrawer/slice/CreateOneOnOneDrawerSlice';
import { getLegacyOneOnOneInstancePagePath, getOneOnOneInstancePagePath } from 'screens/oneOnOneRabbit/helpers';

import { sendClickedOneonOneInstancePageOpened } from 'constants/mixpanelHelper';

export const generateActiveOneOnOneMenuOptions = ({
  data,
  history,
  setIsArchivalDrawerOpen,
  dispatch,
  setDisplayName,
  setMasterId,
  selectedCohort,
}) => {
  const { id: employeeId, displayName } = data?.employee?.value?.employeeMiniProfile ?? {};
  const masterId = data?.employee?.value?.oneOnOneMasterId;
  const instanceId = data?.nextOneOnOne?.value?.latestInstanceId;
  const { isOneOnOneSetup, employeeMiniProfile } = data?.employee?.value ?? {};

  const viewOneonOne = () => {
    sendClickedOneonOneInstancePageOpened({
      eventProperties: {
        source: 'Active 1:1s Table',
      },
    });
    const oneOnOneInstanceExists = !isNaN(instanceId) && !isNaN(masterId);
    if (!oneOnOneInstanceExists) {
      return;
    }
    const route = getOneOnOneInstancePagePath({
      masterId,
      instanceId,
      selectedCohort: selectedCohort.id,
    });
    history.push(route);
  };

  const openArchivalDrawer = () => {
    setDisplayName(displayName);
    setMasterId(masterId);
    setIsArchivalDrawerOpen(true);
  };

  const menuOptions = [
    {
      label: 'View 1:1',
      onClick: viewOneonOne,
    },
    {
      label: 'Archive 1:1',
      onClick: openArchivalDrawer,
    },
  ];

  const openCreateOneOnOneSidepanel = () => {
    dispatch(
      // @ts-ignore
      openCreateOneOnOneDrawer({
        employeeId,
        employeeMiniProfile,
        excludedParticipantIds: [],
      })
    );
  };

  const oneOnOneSetupMenuOptions = [
    {
      label: 'Set timing for 1:1',
      onClick: openCreateOneOnOneSidepanel,
    },
  ];

  return isOneOnOneSetup ? menuOptions : oneOnOneSetupMenuOptions;
};

export const generateArchivedOneOnOneMenuOptions = ({
  data,
  history,
  setIsUnarchivalDrawerOpen,
  setDisplayName,
  setMasterId,
  selectedCohort,
}) => {
  const { displayName } = data?.employee?.value?.employeeMiniProfile ?? {};
  const masterId = data?.employee?.value?.oneOnOneMasterId;
  const instanceId = data?.lastOneOnOneTime?.uuid;
  const legacyInstanceId = data?.employee?.value?.legacyInstanceId;

  const viewOneonOne = () => {
    sendClickedOneonOneInstancePageOpened({
      eventProperties: {
        source: 'Archived 1:1s Table',
      },
    });
    if (legacyInstanceId) {
      const legacyRedirectRoute = getLegacyOneOnOneInstancePagePath({
        legacyInstanceId,
      });
      history.push(legacyRedirectRoute);
      return;
    }
    const oneOnOneInstanceExists = !isNaN(instanceId) && !isNaN(masterId);
    if (!oneOnOneInstanceExists) {
      return;
    }
    const route = getOneOnOneInstancePagePath({
      masterId,
      instanceId,
      selectedCohort: selectedCohort.id,
    });
    history.push(route);
  };

  const openUnArchivalDrawer = () => {
    setDisplayName(displayName);
    setMasterId(masterId);
    setIsUnarchivalDrawerOpen(true);
  };

  const menuOptions = [
    {
      label: 'View 1:1',
      onClick: viewOneonOne,
      disabled: !instanceId && !legacyInstanceId,
    },
    {
      label: 'Unarchive 1:1',
      onClick: openUnArchivalDrawer,
    },
  ];

  return menuOptions;
};
